import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

const guests = [
  { name: "Tihomir Vojnović", table: 1 },
  { name: "Zdravka Vojnović", table: 1 },
  { name: "Đorđo Vojnović", table: 1 },
  { name: "Ljilja Vojnović", table: 1 },
  { name: "Radan Vojnović", table: 1 },
  { name: "Savka Vojnović", table: 1 },
  { name: "Nedo Vujić", table: 1 },
  { name: "Nada Vujić", table: 1 },
  { name: "Dragan Marković", table: 1 },
  { name: "Bogdanka Marković", table: 1 },
  { name: "Neđo Zekanović", table: 2 },
  { name: "Zorica Zekanović", table: 2 },
  { name: "Gorjana Zekanović", table: 2 },
  { name: "Nevena Zekanović", table: 2 },
  { name: "Zoran Petković", table: 2 },
  { name: "Kika Franeta", table: 2 },
  { name: "Branko Čakar", table: 2 },
  { name: "Dragojla Čakar", table: 2 },
  { name: "Zoran Janjušić", table: 2 },
  { name: "Dragica Janjušić", table: 2 },
  { name: "Tatjana Josipović", table: 3 },
  { name: "Luka Josipović", table: 3 },
  { name: "Jelica Josipović", table: 3 },
  { name: "Miodrag Marković", table: 3 },
  { name: "Branka Marković", table: 3 },
  { name: "Nikola Mladenović", table: 3 },
  { name: "Ljubica Mladenović", table: 3 },
  { name: "Nikola Josipović", table: 3 },
  { name: "Violeta Ćorić", table: 3 },
  { name: "Zorica Barbić", table: 3 },
  { name: "Nikola Jakovljević", table: 4 },
  { name: "Kristina Jakovljević", table: 4 },
  { name: "Vojo Vidačak", table: 4 },
  { name: "Anica Vidačak", table: 4 },
  { name: "Zorana Jevtić", table: 4 },
  { name: "Jovana Jevtić", table: 4 },
  { name: "Vladan Vidačak", table: 4 },
  { name: "Stefan Ćorić", table: 4 },
  { name: "Nemanja Ćorić", table: 4 },
  { name: "Ćorić", table: 4 },
  { name: "Anja Trivunović", table: 5 },
  { name: "Dragan Vojnović", table: 5 },
  { name: "Dušica Vojnović", table: 5 },
  { name: "Vladan Vojnović", table: 5 },
  { name: "Jelena Vojnović", table: 5 },
  { name: "Bojana Stević", table: 5 },
  { name: "David Petrović", table: 5 },
  { name: "Miloš Josipović", table: 5 },
  { name: "Marko Josipović", table: 5 },
  { name: "Bogdan Josipović", table: 6 },
  { name: "Radomir Josipović", table: 6 },
  { name: "Branka Josipović", table: 6 },
  { name: "Dule Josipović", table: 6 },
  { name: "Dušanka Josipović", table: 6 },
  { name: "Boško Josipović", table: 6 },
  { name: "Ljilja Josipović", table: 6 },
  { name: "Dobrinko Josipović", table: 6 },
  { name: "Milena Josipović", table: 6 },
  { name: "Nedo Josipović", table: 6 },
  { name: "Branko Josipović", table: 7 },
  { name: "Stana Josipović", table: 7 },
  { name: "Rajko Josipović", table: 7 },
  { name: "Rada Josipović", table: 7 },
  { name: "Darko Krkeljaš", table: 7 },
  { name: "Branka Krkeljaš", table: 7 },
  { name: "Miro Josipović", table: 7 },
  { name: "Tanja Josipović", table: 7 },
  { name: "Mitar Špirić", table: 7 },
  { name: "Kristina Špirić", table: 7 },
  { name: "Njego Josipović", table: 7 },
  { name: "Darko Josipović", table: 8 },
  { name: "Korsa Josipović", table: 8 },
  { name: "Mirko Josipović", table: 8 },
  { name: "Sanja Šarenac Josipović", table: 8 },
  { name: "Mire Zenaković", table: 8 },
  { name: "Tanja Zekanović", table: 8 },
  { name: "Zdravko Karać", table: 8 },
  { name: "Ranko Karać", table: 8 },
  { name: "Dragan Josipović", table: 8 },
  { name: "Sandra Josipović", table: 8 },
  { name: "Nenad Jovanović", table: 8 },
  { name: "Maja Milošević", table: 9 },
  { name: "Kristina Krajišnik", table: 9 },
  { name: "Valentina Maglajčević", table: 9 },
  { name: "Nikola Kolović", table: 9 },
  { name: "Milan Gluhić", table: 9 },
  { name: "Jelenko Mirković", table: 9 },
  { name: "Dragan Perić", table: 9 },
  { name: "Zoran Stupar", table: 9 },
  { name: "Marko Amidžič", table: 9 },
  { name: "Dejan Anđelković", table: 9 },
  { name: "Stefan Josipović", table: 9 },
  { name: "Nikola Blagojević", table: 10 },
  { name: "Adriano Maljković", table: 10 },
  { name: "Darko Zarić", table: 10 },
  { name: "Aleksa Veselinović", table: 10 },
  { name: "Filip Đorđević", table: 10 },
  { name: "Tamara Kostić", table: 10 },
  { name: "Katarina Vasić", table: 10 },
  { name: "Nikola Forkapić", table: 10 },
  { name: "Dijana Dacin", table: 10 },
  { name: "Nataša Kovačević", table: 10 },
  { name: "Dragan Trivunović", table: 11 },
  { name: "Jelena Trivunović", table: 11 },
  { name: "Srđan Terzić", table: 11 },
  { name: "Sanja Terzić", table: 11 },
  { name: "Luka Terzić", table: 11 },
  { name: "Njegoš Terzić", table: 11 },
  { name: "Dragan Terzić", table: 11 },
  { name: "Slava Terzić", table: 11 },
  { name: "Ranka Terzić", table: 11 },
  { name: "Nada Radić", table: 11 },
  { name: "Vido Stanković", table: 12 },
  { name: "Snježana Stanković", table: 12 },
  { name: "Dubravko Stanković", table: 12 },
  { name: "Želimirka Stanković", table: 12 },
  { name: "Darko Stanković", table: 12 },
  { name: "Sandra Stanković", table: 12 },
  { name: "Momir Jovanović", table: 12 },
  { name: "Ilinka Jovanović", table: 12 },
  { name: "Dijana Simikić", table: 12 },
  { name: "Darko Simikić", table: 12 },
  { name: "Dragoslav Crepulja", table: 13 },
  { name: "Slađana Josipović", table: 13 },
  { name: "Zdravko Josipović", table: 13 },
  { name: "Danijela Josipović", table: 13 },
  { name: "Aco Stević", table: 13 },
  { name: "Dejana Stević", table: 13 },
  { name: "Jasna Grujić", table: 13 },
  { name: "Nataša Grujić", table: 13 },
  { name: "Mladen Lujić", table: 13 },
  { name: "Miljana Lujić", table: 13 },
  { name: "Željo Mitrić", table: 14 },
  { name: "Slavica Mitrić", table: 14 },
  { name: "Spomenko Stanković", table: 14 },
  { name: "Verica Stanković", table: 14 },
  { name: "Predo Cvijanović", table: 14 },
  { name: "Vladislava Kokotović", table: 14 },
  { name: "Dragan Marković", table: 14 },
  { name: "Mara Marković", table: 14 },
  { name: "Slavko Janjušić", table: 14 },
  { name: "Marica Janjušić", table: 14 },
  { name: "Stefan Zindović", table: 15 },
  { name: "Nikola Jovišić", table: 15 },
  { name: "Jelena Petković", table: 15 },
  { name: "Danica Zec", table: 15 },
  { name: "Aleksa Đorović", table: 15 },
  { name: "Aleksandar Milaković", table: 15 },
  { name: "Marija Grujić", table: 15 },
  { name: "Slaviša Bulajić", table: 15 },
  { name: "Srđan Josipović", table: 15 },
  { name: "Sara Josipović", table: 15 },
  { name: "Mihajlo Vujičić", table: 16 },
  { name: "Nemanja Radoičić", table: 16 },
  { name: "Bojan Baškalo", table: 16 },
  { name: "Veljko Tošić", table: 16 },
  { name: "Aleksa Kralj", table: 16 },
  { name: "Anđela Đurić", table: 16 },
  { name: "Ivana Gavrić", table: 16 },
  { name: "Kristina Todorović", table: 16 },
  { name: "Dajana Jandrić", table: 16 },
  { name: "Dejan Pelemiš", table: 16 },
  { name: "Ljubiša Perić", table: 16 },
  { name: "Stanko Nedić", table: 17 },
  { name: "Radmila Nedić", table: 17 },
  { name: "Nevenko Planinac", table: 17 },
  { name: "Rosa Planinac", table: 17 },
  { name: "Mladenka Stolić", table: 17 },
  { name: "Milan Stolić", table: 17 },
  { name: "Joka Aleksić", table: 17 },
  { name: "Željo Terzić", table: 17 },
  { name: "Željo Ubiparipovic", table: 17 },
  { name: "Tihomir Šarenac", table: 18 },
  { name: "Dejana Stajić", table: 18 },
  { name: "Mika Nedić", table: 18 },
  { name: "Dragica Nedić", table: 18 },
  { name: "Dalibor Nedić", table: 18 },
  { name: "Gordana Nedić", table: 18 },
  { name: "Mišo Vojnović", table: 18 },
  { name: "Milenka Vojnović", table: 18 },
  { name: "Novak Šarić", table: 18 },
  { name: "Nina Šarić", table: 18 },
  { name: "Velimir Ružičić", table: 19 },
  { name: "Željka Ružičić", table: 19 },
  { name: "Radomir Ružičić", table: 19 },
  { name: "Gospava Ružičić", table: 19 },
  { name: "Predo Ružičić", table: 19 },
  { name: "Nada Ružičić", table: 19 },
  { name: "Lana Ružičić", table: 19 },
  { name: "Brano Josipović", table: 19 },
  { name: "Željka Josipović", table: 19 },
  { name: "Milan Đukić", table: 19 },
  { name: "Stanka Đukić", table: 19 },
  { name: "Neno Ćorić", table: 20 },
  { name: "Svjetlana Ćorić", table: 20 },
  { name: "Vito Vidačak", table: 20 },
  { name: "Ankica Vidačak", table: 20 },
  { name: "Todor Vidačak", table: 20 },
  { name: "Dada Vidačak", table: 20 },
  { name: "Rado Jevtić", table: 20 },
  { name: "Sretanka Jevtić", table: 20 },
  { name: "Mladenko Vidačak", table: 20 },
  { name: "Zvjezdana Vidačak", table: 20 },
  { name: "Nedo Vidačak", table: 21 },
  { name: "Vitka Vidačak", table: 21 },
  { name: "Dejo Vidačak", table: 21 },
  { name: "Dragan Nikolić", table: 21 },
  { name: "Dijana Nikolić", table: 21 },
  { name: "Luka Nikolić", table: 21 },
  { name: "Kristijan Nikolić", table: 21 },
  { name: "Mladenko Ćorić", table: 21 },
  { name: "Ljilja Ćorić", table: 21 },
  { name: "Milica Špirić", table: 22 },
  { name: "Marija Špirić", table: 22 },
  { name: "Nevena Josipović", table: 22 },
  { name: "Miloš Josipović", table: 22 },
  { name: "Njegoš Krkeljaš", table: 22 },
  { name: "Đorđe Josipović", table: 22 },
  { name: "Luka Josipović", table: 22 },
  { name: "Bogdan Josipović", table: 22 },
  { name: "Nemanja Josipović", table: 22 },
  { name: "Vasilije Josipović", table: 22 },
  { name: "Ilija Josipović", table: 22 },

  { name: "Jevtić Miroljub", table: 23 },
  { name: "Jevtić Ranka", table: 23 },
  { name: "Jevtić Bogoljub", table: 23 },
  { name: "Jevtić Milka", table: 23 },
  { name: "Ristić Milena", table: 23 },
  { name: "Ristić Milenko", table: 23 },
  { name: "Ristić Nađa", table: 23 },
  { name: "Ristić Jovan", table: 23 },
  { name: "Ristić Miloš", table: 23 },
  { name: "Jevtić Ceca", table: 23 },
  { name: "Tomić Janko", table: 23 },

  { name: "Jevtić Valentina", table: 24 },
  { name: "Nikolić Nikolina", table: 24 },
  { name: "Mirosavljević Jelena", table: 24 },
  { name: "Matić Katarina", table: 24 },
  { name: "Baljicki Sonja", table: 24 },
  { name: "Milović Mila", table: 24 },
  { name: "Matejić Dunja", table: 24 },
  { name: "Gordanić Dušan", table: 24 },
  { name: "Ristić Milica", table: 24 },
  { name: "Ristić Tomislav", table: 24 },

  { name: "Mitrović Tamara", table: 25 },
  { name: "Smiljanić Biljana", table: 25 },
  { name: "Jevtić Mladen", table: 25 },
  { name: "Jevtić Filip", table: 25 },
  { name: "Jevtić Mihajlo", table: 25 },
  { name: "Filipović Dragana", table: 25 },
  { name: "Panić Miloš", table: 25 },
  { name: "Tošić Nikolina", table: 25 },
  { name: "Lukić Ivana", table: 25 },

  { name: "Vojvodić Dragan", table: 26 },
  { name: "Vojvodić Bojana", table: 26 },
  { name: "Nemet Marko", table: 26 },
  { name: "Nikolić Milana", table: 26 },
  { name: "Matić Matina", table: 26 },
  { name: "Popović Milica", table: 26 },
  { name: "Trivundža Miloš", table: 26 },
  { name: "Lazarević Jovana", table: 26 },
  { name: "Pantelić Kosta", table: 26 },
  { name: "Pantelić Olja", table: 26 },

  { name: "Jokić Nedeljko", table: 27 },
  { name: "Jokić Tanja", table: 27 },
  { name: "Jokić Siniša", table: 27 },
  { name: "Jokić Sanja", table: 27 },
  { name: "Nikolić Danijela", table: 27 },
  { name: "Nikolić Vanja", table: 27 },
  { name: "Bajagić Dragutin", table: 27 },
  { name: "Bajagić Maja", table: 27 },
  { name: "Bajagić Ivana", table: 27 },
  { name: "Jeremić Dragana", table: 27 },

  { name: "Jokić Zoran", table: 28 },
  { name: "Savić Kristina", table: 28 },
  { name: "Jokić Goran", table: 28 },
  { name: "Jokić Marijana", table: 28 },
  { name: "Smiljanić Pero", table: 28 },
  { name: "Smiljanić Rada", table: 28 },
  { name: "Smiljanić Sara", table: 28 },
  { name: "Jokić Cvjetko", table: 28 },
  { name: "Jokić Mara", table: 28 },

  { name: "Jokić Marko", table: 29 },
  { name: "Jokić Anica", table: 29 },
  { name: "Jokić Srećo", table: 29 },
  { name: "Djurov Ana", table: 29 },
  { name: "Jokić Veljko", table: 29 },
  { name: "Jokić Dragan", table: 29 },
  { name: "Ivanović Željka", table: 29 },
  { name: "Ivanović Milenko", table: 29 },
  { name: "Mihajlović Željko", table: 29 },
  { name: "Jokić Zorana", table: 30 },
  { name: "Jokić Anđela", table: 30 },
  { name: "Jokić Bojana", table: 30 },
  { name: "Rankić Miloš", table: 30 },
  { name: "Jokić Dejan", table: 30 },
  { name: "Jokić Sandra", table: 30 },
  { name: "Novičić Slađan", table: 30 },
  { name: "Novičić Jelena", table: 30 },
  { name: "Miličić Aleksandar", table: 30 },
  { name: "Miličić Mladen", table: 30 },

  { name: "Pavlović Milan", table: 31 },
  { name: "Pavlović Nevena", table: 31 },
  { name: "Pavlović Marko", table: 31 },
  { name: "Pavlović Vera", table: 31 },
  { name: "Pavlović Darko", table: 31 },
  { name: "Pavlović Sanja", table: 31 },
  { name: "Pavlović Dalibor", table: 31 },
  { name: "Pavlović Jovana", table: 31 },
  { name: "Đurić Verica", table: 31 },
  { name: "Đurić Andrej", table: 31 },
  { name: "Đurić Andrea", table: 31 },

  { name: "Miličić Velemir", table: 32 },
  { name: "Miličić Slavica", table: 32 },
  { name: "Novičić Dobrila", table: 32 },
  { name: "Smiljanić Dragan", table: 32 },
  { name: "Erkić Milana", table: 32 },
  { name: "Erkić Željana", table: 32 },
  { name: "Čekić Stana", table: 32 },
  { name: "Ašćerić Stanimir", table: 32 },
  { name: "Ašćerić Cveta", table: 32 },
  { name: "Filipović Snežana", table: 32 },
  { name: "Filipović Cane", table: 32 },

  { name: "Miletić Mladenka", table: 33 },
  { name: "Pisić Ceca", table: 33 },
  { name: "Gračanin Dragana", table: 33 },
  { name: "Tadić Verica", table: 33 },
  { name: "Stojanović Ljubinka", table: 33 },
  { name: "Tanacković Suzana", table: 33 },
  { name: "Jovanović Aleksandar", table: 33 },
  { name: "Tanacković Filip", table: 33 },
  { name: "Lazić Milan", table: 33 },
  { name: "Stanković Živorad", table: 33 },

  { name: "Jevtić Ivan", table: 34 },
  { name: "Jevtić Vera", table: 34 },
  { name: "Jevtić Isidora", table: 34 },
  { name: "Jevtić Momčilo", table: 34 },
  { name: "Jevtić Đurđa", table: 34 },
  { name: "Stanojević Suzana", table: 34 },
  { name: "Stanojević Saša", table: 34 },
  { name: "Stanojević Luka", table: 34 },
  { name: "Stanojević Lenka", table: 34 },
  { name: "Jevtić Tomo", table: 34 },
  { name: "Jevtić Nena", table: 34 },

  { name: "Jevtić Milan", table: 35 },
  { name: "Jevtić Marija", table: 35 },
  { name: "Jevtić Andrej", table: 35 },
  { name: "Jevtić Dimitrije", table: 35 },
  { name: "Jevtić Dragan", table: 35 },
  { name: "Jevtić Daniela", table: 35 },
  { name: "Jevtić Radenko", table: 35 },
  { name: "Jevtić Branko", table: 35 },
  { name: "Jevtić Maja", table: 35 },
  { name: "Lukić Milan", table: 35 },
  { name: "Lukić Marica", table: 35 },

  { name: "Tomić Slavica", table: 36 },
  { name: "Tomić Ivan", table: 36 },
  { name: "Jevtić Milojko", table: 36 },
  { name: "Jevtić Ivana", table: 36 },
  { name: "Jevtić Dragan", table: 36 },
  { name: "Jevtić Slavojka", table: 36 },
  { name: "Jevtić Radovan", table: 36 },
  { name: "Jevtić Milovan", table: 36 },
  { name: "Tešić Ljilja", table: 36 },
  { name: "Tešić Mladenka", table: 36 },

  { name: "Jevtić Zoran", table: 37 },
  { name: "Jevtić Milka", table: 37 },
  { name: "Jevtić Živorad", table: 37 },
  { name: "Jevtić Gordana", table: 37 },
  { name: "Jevtić Mišo", table: 37 },
  { name: "Jevtić Mica", table: 37 },
  { name: "Jevtić Željko", table: 37 },
  { name: "Jevtić Željko", table: 37 },
  { name: "Jevtić Boba", table: 37 },
  { name: "Jevtić Neda", table: 37 },
  { name: "Jevtić Nika", table: 37 }
];

function App() {
  const [query, setQuery] = React.useState("");
  const filtered = guests.filter(g =>
    g.name.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-pink-100 flex flex-col items-center justify-center p-4 font-poppins">
      <h1 className="text-4xl font-bold mb-6">Pronađi svoj sto</h1>
      <input
  className="p-3 border border-pink-400 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent mb-6 w-full max-w-sm transition duration-300"
  placeholder="Unesi ime i prezime"
  onChange={e => setQuery(e.target.value)}
/>
      <div className="space-y-4">
        {filtered.map((g, i) => (
          <div key={i} className="text-center text-lg bg-white p-4 rounded-lg shadow-sm">
  <p className="font-semibold text-pink-700">{g.name}</p>
  <p className="text-gray-600">Sto broj: {g.table}</p>
</div>
        ))}
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);